/**
 * Stop-Go lamp
 * - used in Olsztyn
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Sg extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'sg',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Line({
        points: [15, 30, 15, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 50, 30, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      // display of signals
      // GO STRAIGHT: |
      // GO LEFT: \
      // GO RIGHT: /
      // STOP: --

      // signals
      new Ren.Line({
        name: 'stop',
        points: [5, 15, 25, 15],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'right',
        points: [5, 25, 25, 5],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'left',
        points: [5, 5, 25, 25],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Rect({
        name: 'redDot',
        x: 20,
        y: 20,
        width: 5,
        height: 5,
        strokeWidth: 0.5,
        fill: Color.red,
        opacity: 0.8,
        visible: false
      }),

      new Ren.Line({
        name: 'go',
        points: [15, 5, 15, 25],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      })
    )
  }

  showDirection (status) {
    this.modifyShape('stop', 'visible', status.signalStop === 1)
    this.modifyShape('go', 'visible', status.signalGoStraight === 1)
    this.modifyShape('left', 'visible', status.signalGoLeft === 1)
    this.modifyShape('right', 'visible', status.signalGoRight === 1)
    this.modifyShape('redDot', 'visible', status.trackReserved === 1)
  }

  blinkSignal (signalName) {
    let active = false
    return setInterval(() => {
      active = !active
      console.log(`signal ${signalName} is active: ${active}`)
      this.modifyShape(signalName, 'visible', active)
      const layer = this.shapes.find(s => s.attrs.name === signalName).getLayer()
      if (layer) {
        layer.batchDraw()
      }
    }, 1000)
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    console.log('applygin status', status)
    super.applyStatusOnShapes(newVariables)
    if (status.signalStopBlink === 1) {
      console.log('running interval')
      this.interval = this.blinkSignal('stop')
    } else {
      clearInterval(this.interval)
      this.modifyShape('stop', 'visible', false)
    }

    this.showDirection(status)
  }
}
